import { Component, Input } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Router } from '@angular/router';

@Component({
  selector: 'unh-banner-default',
  templateUrl: './banner-default.component.html',
  styleUrls: ['./banner-default.component.scss']
})
export class BannerDefaultComponent {
  @Input() title: any;
  @Input() subtitle: any;
  @Input() lead: any;
  @Input() banner: any;
  @Input() bannermobile: any;
  @Input() link: any;
  @Input() linktext: any;
  @Input() subscribed: any;
  @Input() cta = false;
  @Input() enabledGetPro = true;
  @Input() linkTarget: string;
  @Input() queryParams = null;
  @Input() state = null;
  @Input() isSubscribed = false;
  @Input() showBoth = false;

  isMobile: boolean;

  constructor(
    private bkos: BreakpointObserver,
    private router: Router
  ) {
    this.bkos
      .observe('(max-width: 480px)')
      .subscribe((bo) => (this.isMobile = bo.matches));
  }

  navigateTo(target, queryParams?, state?) {
    if(this.link){
      if (target != '_blank') {
        this.router.navigate([this.link], {queryParams, state} );
      }else{
        window.open(this.link, "_blank");
      }
    }
  }


}
